import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { Report } from 'src/app/reports/components/report/models/report.model';
import { ReportSettings } from '../report-settings/models/reportsettings.model';
import { Filter } from '../../report/models/filter.model';
import { RTEAlertService } from 'rte-library';
import { isFormValid } from 'src/app/reports/shared/rte-form/schema/schema.helper';
import { ReportFormViewComponent } from '../report-form-view/report-form-view.component';
import { ReportService } from '../../report/report.service';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';
import { ReportRender } from 'src/app/models/reportRender';
import { getAllFilters } from 'src/app/reports/helpers/filter.helper';
import { getQueryParameterList } from 'src/app/reports/helpers/query-parameter.helper';
import { Schema, SchemaForm } from 'src/app/reports/shared/rte-form/schema/schema.model';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.scss']
})
export class ReportViewComponent extends BaseComponent implements OnInit, AfterContentInit {

  //#region Inputs
  @Input() report: Report;
  @Input() readonly = true;
  @Input() showRteTitle = true;
  @Input() showReportRender: ReportRender;
  @Input() settings: ReportSettings;
  @Input() form: SchemaForm;
  @Input() schemasWithFileUpload: Schema[] = [];

  //#endregion

  //#region Properties
  parameter: any = {};
  filters: Array<Filter> = [];

  @ViewChild(ReportFormViewComponent) reportFormView: ReportFormViewComponent;

  @Output() loading: EventEmitter<ReportViewComponent> = new EventEmitter<ReportViewComponent>();

  //#endregion

  //#region Ctor

  constructor(private alert: RTEAlertService,
    private reportService: ReportService) {
      super();
    }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    if (this.report) {
      this.report = {... this.report};
      this.filters = getAllFilters(this.report);
    }
  }

  ngAfterContentInit(): void {
    setTimeout(_ => this.loadingComponent());
  }

  loadingComponent() {
    if (this) {
      this.loading.emit(this);
    }
  }

  setParameter(parameter: any): void {
    const obj = new Report();
    obj.Id = parameter;

    this.subscription.add(
      this.reportService.get(obj, 1, 1).subscribe(x => {
        if (x && x.Data && x.Data.length === 1) {
          this.report = {... x.Data[0]};
          this.filters = getAllFilters(this.report);
        }
      })
    );
  }

  //#endregion

  //#region Events

  onViewReportClick() {
    const isValid = this.reportFormView != null ? isFormValid(this.form, this.parameter) : true;

    if (isValid) {
      this.showReport();
    } else {
      this.sendMessageInvalid();
    }
  }

  sendMessageInvalid() {
    this.showReportRender.showReportView = true;
    this.showReportRender.showReportRender = false;
    this.showReportRender.parameter = null;
    this.showReportRender.settings = null;
    this.alert.warning('Há um ou mais campos inválidos. Por favor, verifique os filtros');

    document.querySelectorAll('app-report-form-view input').forEach((element: any) => {
      element.focus();
      element.blur();
    });
  }

  showReport() {
    this.showReportRender.showReportView = false;
    this.showReportRender.showReportRender = true;
    this.showReportRender.parameter = getQueryParameterList(this.filters, this.parameter);
    this.showReportRender.settings = this.settings;
  }

  //#endregion
}
